import _taggedTemplateLiteral from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from "styled-components";
import { colors, size } from "./../../../shared/constants";
import { BaseText } from "./../styles";
var OrderSummaryRow = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"]))),
    RowLabel = styled(BaseText)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: ", "px 0;\n  font-size: ", "px;\n"])), size.xs3, function (e) {
  return e.showAsTitle ? "20.3" : size.md;
}),
    RowPrice = styled(RowLabel)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), colors.gray5),
    FreeLabel = styled(BaseText)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-grow: 0;\n  font-size: 14.2px;\n  line-height: 1.55;\n  letter-spacing: 0.5px;\n"])));
export { RowLabel, RowPrice, FreeLabel, OrderSummaryRow };